module.exports = __webpack_public_path__ + "img/8.65ff637f.png";